<template>
	<div style = "margin-top:30px">
		<div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/>
		<div class = "col-sm-12 row" v-else >
			<div class = "col-sm-8">
				<form v-on:submit.prevent>
					<div class="form-group row" >
						<label class="col-sm-3 col-form-label">
							Vendor Name
							<sup>*</sup>
						</label>
						<div class="col-sm-7 pr-5">
							<!-- <input
								type="text"
								name="title"
								v-model="vendorData.vendor_name"
								:class="{ 'is-invalid': submitted && (!vendorData.vendor_name || vendorData.vendor_name == null || vendorData.vendor_name == 'null') }"
								class="form-control"
								id="title"
								:disabled="isVendor"
								placeholder="Enter vendor name"
							> -->
							<multiselect
								v-model="vendorData.vendor"
								:options="vendorList"
								label="name"
								:searchable="true"
								ref="multiselect"
								track-by="name"
								open-direction="bottom"
								placeholder="Select vendor"
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								tagPlaceholder="Press enter to create new vendor"
								autocomplete="off"
								style="max-height:40px;"
								:multiple="false"
								id="vendor"
								:loading="isLoading"
								:taggable="true"
								@select = "selectNewVendor"
								@tag="addNewVendor"
								:class="{ 'is-invalid': submitted && (!vendorData.vendor || vendorData.vendor == null || vendorData.vendor == 'null') }"
							/>
							<span
								v-if="submitted && (!vendorData.vendor || vendorData.vendor == null || vendorData.vendor == 'null')"
								class="invalid-feedback"
							>This field is required</span>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Brand Entity Id
						</label>
						<div class="col-sm-7 pr-5">
							<input
								type="text"
								name="entityId"
								v-model="vendorData.brand_entity_id"
								class="form-control"
								id="entityId"
								placeholder="Enter brand entity id"
								autocomplete = "off"
							>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Country
							<sup>*</sup>
						</label>
						<div class="col-sm-7 pr-5">
							<input
								type="text"
								name="entityId"
								v-model="vendorData.country_code"
								class="form-control"
								id="entityId"
								placeholder="Enter country code"
								:disabled="isCountryCode"
								:class="{ 'is-invalid': submitted && (!vendorData.country_code || vendorData.country_code == null || vendorData.country_code == 'null') }"
								autocomplete = "off"
							>
							<span
								v-if="submitted && (!vendorData.country_code || vendorData.country_code == null || vendorData.country_code == 'null')"
								class="invalid-feedback"
							>This field is required</span>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Profile Brand Name
							<sup>*</sup>
						</label>
						<div class="col-sm-7 pr-5">
							<!-- <input
							    v-if = "!isEditPage"
								type="text"
								:class="{ 'is-invalid': submitted && (!vendorData.profile_brand_name || vendorData.profile_brand_name == null || vendorData.profile_brand_name == 'null') }"
								name="retailContact"
								v-model="vendorData.profile_brand_name"
								class="form-control"
								id="retailContact"
								placeholder="Enter profile brand name"
								autocomplete = "off"
							> -->
							<multiselect
								v-model="vendorData.profile_brand_name"
								:options="brandsList"
								label="name"
								:searchable="true"
								ref="multiselect"
								track-by="name"
								open-direction="bottom"
								placeholder="Select Brand Profile"
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								tagPlaceholder="Press enter to create new brand"
								autocomplete="off"
								style="max-height:40px;"
								:multiple="false"
								id="brands"
								:loading="isLoadingBrand"
								:taggable="true"
								@tag="addNewBrand"
								:class="{ 'is-invalid': submitted && (!vendorData.profile_brand_name || vendorData.profile_brand_name == null || vendorData.profile_brand_name == 'null') }"
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Client Main Contact</label>
						<div class="col-sm-7 pr-5">
							<multiselect
								v-model="vendorData.client_main_contact"
								:options="contacts_list"
								:searchable="true"
								ref="multiselect"
								:custom-label="customLabel"
								label="first_name"
								track-by="first_name"
								open-direction="bottom"
								placeholder="Search..."
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								autocomplete="off"
								style="max-height:40px;"
								:multiple="false"
								id="clsient"
								:taggable="true"
								tagPlaceholder="Press enter to create new contact"
								@tag="addNew($event,'client')"
							>
								<template slot="noResult">
									<div @click="addNew('client')">Add new client contact</div>
								</template>
							</multiselect>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Go Retail Contact</label>
						<div class="col-sm-7 pr-5">
							<multiselect
								v-model="vendorData.go_retail"
								:options="contacts_list"
								:searchable="true"
								@search-change="updateName"
								ref="multiselect"
								track-by="first_name"
								:custom-label="customLabel"
								open-direction="bottom"
								placeholder="Search..."
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								tagPlaceholder="Press enter to create new contact"
								autocomplete="off"
								style="max-height:40px;"
								:multiple="false"
								id="retail"
								:taggable="true"
								@tag="addNew($event,'retail')"
							>
								<template slot="noResult">
									<div @click="addNew('retail')">Add new retail contact</div>
								</template>
							</multiselect>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Go Marketing Contact</label>
						<div class="col-sm-7 pr-5">
							<multiselect
								v-model="vendorData.go_marketing"
								:options="contacts_list"
								:searchable="true"
								ref="multiselect"
								label="first_name"
								:custom-label="customLabel"
								track-by="first_name"
								open-direction="bottom"
								placeholder="Search..."
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								autocomplete="off"
								style="max-height:40px;"
								:multiple="false"
								id="market"
								tagPlaceholder="Press enter to create new contact"
								:taggable="true"
								@tag="addNew($event,'market')"
							>
								<template slot="noResult">
									<div @click="addNew('market')">Create new market contact</div>
								</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Go Ops Contact</label>
						<div class="col-sm-7 pr-5">
							<multiselect
								v-model="vendorData.go_ops"
								:options="contacts_list"
								:searchable="true"
								ref="multiselect"
								:custom-label="customLabel"
								label="first_name"
								track-by="first_name"
								open-direction="bottom"
								placeholder="Search..."
								class="form-control multi-dropdown"
								selectLabel
								deselectLabel
								selectedLabel
								autocomplete="off"
								tagPlaceholder="Press enter to create new contact"
								style="max-height:40px;"
								:multiple="false"
								id="ops"
								:taggable="true"
								@tag="addNew($event,'ops')"
							>
								<template slot="noResult">
									<div @click="addNew('ops')">Create new ops contact</div>
								</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Annual Goal
						</label>
						<div class="col-sm-7 pr-5">
							<input
								type="number"
								name="annualGoal"
								v-model="vendorData.annual_goal"
								class="form-control"
								id="entityId"
								placeholder="Enter Annual Goal"
								autocomplete = "off"
							>
						</div>
					</div>
					<div class="form-group row" style="padding-left:0px">
						<div class="col-sm-3 col-form-label">
							<label class="form-check-label">FBA</label>
						</div>
						<div class="col-sm-7">
							<div class="form-check d-inline-block" style="display:flex !important">
								<input
									type="checkbox"
									v-model="vendorData.fba"
									value="true"
									style="padding-bottom:5px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Base Api Url
							<sup>*</sup>
						</label>
						<div class="col-sm-7 pr-5">
							<input
								type="text"
								name="baseApiUrl"
								v-model="vendorData.base_api_url"
								class="form-control"
								id="baseApiUrl"
								placeholder="Enter base api url"
								:disabled="isBaseApiUrl"
								autocomplete = "off"
							>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">
							Monthly Budget
						</label>
						<div class="col-sm-7 pr-5">
							<input
								type="number"
								name="baseApiUrl"
								v-model="vendorData.monthly_budget"
								class="form-control"
								id="baseApiUrl"
								placeholder="Enter Monthly Budget"
								autocomplete = "off"
							>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Data pull</label>
						<div class="col-sm-7">
							<div class="form-check d-inline-block">
								<input
									class="form-check-input"
									v-model="vendorData.data_pull"
									type="radio"
									name="DataPull"
									id="DataPull"
									:value='true'
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="Type1"
									style="vertical-align: middle !important;"
								>True</label>
							</div>
							<div class="form-check d-inline-block ml-3">
								<input
									class="form-check-input"
									v-model="vendorData.data_pull"
									type="radio"
									name="DataPull"
									id="DataPull"
									:value="false"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="Type2"
									style="vertical-align: middle !important;"
								>False</label>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">ARA</label>
						<div class="col-sm-7">
							<div class="form-check d-inline-block">
								<input
									class="form-check-input"
									v-model="vendorData.ara_type"
									type="radio"
									name="AraType"
									id="AraType"
									value="Basic"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="TargetingType1"
									style="vertical-align: middle !important;"
								>Basic</label>
							</div>
							<div class="form-check d-inline-block ml-3">
								<input
									class="form-check-input"
									v-model="vendorData.ara_type"
									type="radio"
									name="AraType"
									id="AraType"
									value="Premium"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="TargetingType2"
									style="vertical-align: middle !important;"
								>Premium</label>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Profile Type</label>
						<div class="col-sm-7">
							<div class="form-check d-inline-block">
								<input
									type="checkbox"
									v-model="vendorData.profile_type_seller"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="TargetingType1"
									style="vertical-align: middle !important;"
								>Seller</label>
							</div>
							<div class="form-check d-inline-block ml-3">
								<input
									type="checkbox"
									v-model="vendorData.profile_type_vendor"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="TargetingType2"
									style="vertical-align: middle !important;"
								>Vendor</label>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-3 col-form-label">Marketing Campaign Type</label>
						<div class="col-sm-9">
							<div class="form-check d-inline-block">
								<input
									type="checkbox"
									v-model="vendorData.marketing_campaign_sb"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="dataPull1"
									style="vertical-align: middle !important;"
								>Sponsored Brands</label>
							</div>
							<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
								<input
									type="checkbox"
									v-model="vendorData.marketing_campaign_sp"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="dataPull2"
									style="vertical-align: middle !important;"
								>Sponsored Products</label>
							</div>
							<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
								<input
									type="checkbox"
									v-model="vendorData.marketing_campaign_sd"
									value="true"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label
									class="form-check-label"
									for="dataPull2"
									style="vertical-align: middle !important;"
								>Sponsored Display</label>
							</div>
						</div>
					</div>

					<div class="form-group row" style="padding-left:0px" v-if="isEditPage">
						<div class="col-sm-3 col-form-label">
							<label class="form-check-label" for="exampleCheck1">Active</label>
						</div>
						<div class="col-sm-1">
							<div class="form-check d-inline-block" style="display:flex !important">
								<input
									type="checkbox"
									v-model="vendorData.active"
									value="true"
									style="padding-bottom:5px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
									@click = "activeValueChange"
								>
							</div>
						</div>
						<div class = "col-sm-6 form-group row" v-if = "showDate">
							<div class="col-sm-7 col-form-label" style = "padding-top:0px">
								<label class="form-check-label" for="exampleCheck1">Future Date To Disable</label>
								<p style = "font-size:13px;color:red">(Update will happen at 11:59pm on selected date)</p>
							</div>
							<div class="col-sm-2" style="padding-top:0px">
								<input
									type="date"
									id="start"
									name="disable_date"
								    v-model="vendorData.disable_date"
								    :min="min_date"
									class="form-check-input"
									style = "margin:0px"
									>
							</div>
						</div>
						<div class="col-sm-2" style = "text-align:center" v-if = "showDate && vendorData.disable_date">
							<p style = "font-size:13px;color:orange">Pending InActive</p>
						</div>
					</div>

					<div class="form-group row">
						<button class="btn btn-secondary" @click="navigateToListPage('cancel')">Cancel</button>
						<button class="btn btn-primary" @click="saveVendor()">Save</button>
					</div>
				</form>
			</div>
			<div class = "col-sm-4" v-if = "isEditPage">
				<div style = "width:100%;">
					<div style = "text-align: left;padding: 5px;background: #3da3a7;margin-bottom: 10px;"><h4 style = "margin-bottom:0px;color:#ffffff">Brand Profiles</h4></div>

					<div v-if = "otherBrands.length" style = "padding-top: 10px;padding-bottom: 15px;border: 1px solid #ced4da;max-height:300px;overflow: scroll;" >
						<div class="" v-for = "(element,index) in otherBrands" :key = "index">
							<p style = "padding-left:15px"><a href="javascript:void(0)" @click = "changeprofile(element.profile_id,element.profile_brand_name)">{{element.profile_brand_name }}</a></p>
						</div>
					</div>
					<div v-else><p style = "padding-left:10px;padding-bottom:15px">No Other Profile With Vendor</p></div>
				</div>

				<div style = "width:100%;margin-top:40px;">
					<div style = "text-align: left;padding: 5px;background: #3da3a7;"><h4 style = "margin-bottom:0px;color:#ffffff">YTD Shipped Cogs</h4></div>
					<div v-if = "cogs.length" style = "padding-top: 10px;padding-bottom: 15px;border: 1px solid #ced4da;max-height:500px;overflow: scroll;" >
						<table class="table">
							<thead>
								<tr style = "">
									<th>Asin</th>
									<th>Title</th>
									<th>Shipped Cogs</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for = "(element,index) in cogs" :key = "index">
									<td>{{element.asin}}</td>
									<td>{{element.producttitle}}</td>
									<td>{{element.shippedcogs}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else><p style = "padding-left:10px;padding-bottom:15px">No Shipped Cogs</p></div>
				</div>

			</div>
			<AddContactModal
				v-if="openAddNewContactModal"
				@closeAddContactModal="closeAddContactModal"
				:addedNewName="addedNewName"
			/>
		</div>
		<!-- <div v-if = "isEditPage && vendorData && vendorData.profile_brand_name && vendorData.profile_brand_name.name">
			<script type='application/javascript' src='https://us-east-1.online.tableau.com/javascripts/api/viz_v1.js'></script>
				<div class='tableauPlaceholder' style='width: 1366px; height: 818px;'>
					<object class='tableauViz' width='1366' height='818' style='display:none;'>
						<param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' />
						<param name='embed_code_version' value='3' />
						<param name='site_root' value='t/globaloverview' />
						<param name='name' value='NewAMS_15743716531840/BudgetDashboard' />
						<param name='tabs' value='yes' /><param name='toolbar' value='yes' />
						<param name='showAppBanner' value='false' />
				</object>
			</div>
		</div> -->
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import AddContactModal from "@/components/account-management/AddContactModal";
	import moment from "moment";

	export default {
		name: "AddVendorForm",
		data() {
			return {
				isEditPage: false,
				loader: false,
				openAddNewContactModal: false,
				contacts_list: [],
				vendorData: {
					profile_id: "",
					vendor: "",
					go_vendor_cd: "",
					ams_profile_id: "",
					brand_entity_id: "",
					profile_brand_name: "",
					active: true,
					country_code: "",
					base_api_url: "",
					profile_type_seller: "",
					profile_type_vendor: "",
					marketing_campaign_sp: "",
					marketing_campaign_sb: "",
					marketing_campaign_sd: "",
					ara_type: "",
					client_main_contact: "",
					profile_type: "",
					data_pull: "",
					go_retail: "",
					go_vendor: "",
					go_marketing: "",
					go_ops: "",
					base_api_url:'',
					annual_goal: '',
					fba:'',
					montly_budget:'',
					disable_date:''
				},
				submitted: false,
				editable: true,
				retail: [],
				market: [],
				ops: [],
				client: [],
				createNew: {
					account_name: "Create New"
				},
				name: "",
				addedType: "",
				isVendor: false,
				addedNewName: "",
				vendorList:[],
				isCountryCode:false,
				isBaseApiUrl:false,
				isDataPull:false,
				otherBrands:[],
				cogs:[],
				toggleList:[],
				isLoading:false,
				brandsList:[],
				isLoadingBrand:false,
				showDate:false,
				disableDateCopy:''
			};
		},
		components: { Multiselect, AddContactModal, moment },
		mounted() {
			this.getData();
			this.getTableauReport()


			//this.getGoCalls(this.$route.params.ProfileId,'all');
		},
		computed:{
			min_date(){
				return  moment().format("YYYY-MM-DD");
			}
		},
		watch: {
			isEditPage() {
				if (this.isEditPage) {
					this.getVendorDataById();
				}
			},
			// retail(){
			// 	if(this.retail.account_name=='Create New'){

			// 	}
			// },
			// market(){
			// 	if(market.account_name=='Create New'){

			// 	}
			// },
			// contact(){
			// 	if(contact.account_name=='Create New'){

			// 	}
			// },
			// ops(){
			// 	if(ops.account_name=='Create New'){

			// 	}
			// }
		},
		methods: {
			getTableauReport(){
				let vm = this;
				if(this.isEditPage){
					const intervalTimer = setInterval(()=>{
								vm.vendorData.profile_brand_name && (clearInterval(intervalTimer) && vm.vendorData.profile_brand_name || document.querySelector('.tableauPlaceholder iframe').setAttribute('src', document.querySelector('.tableauPlaceholder iframe').getAttribute('src') + `&Profile Brand Name=${vm.vendorData.profile_brand_name.name}`))
						}, 5000)
				}
			},
			getData(){
				this.checkIfAddOrEdit(this.$route.params.ProfileId);
				if(this.isEditPage){
					this.getOtherBrandsList();
				}
				this.getContactsList();
			//	this.getCogsList()
			},
			activeValueChange(val){

				if(!val.currentTarget.checked){
					this.showDate = true;
				}
				else{
					this.showDate = false;
					this.vendorData.disable_date = '';
				}
			},
			addNewVendor(data){

				this.vendorData.vendor = {name: data}
				this.vendorList.push({name:data});
				this.brandsList = [];
				this.vendorData.profile_brand_name = "";
			},
			addNewBrand(data){
				this.vendorData.profile_brand_name = {name:data}
				this.brandsList.push({name:data})
			},
			openAddModal() {},
			selectNewVendor(data){
			this.isLoading = true
		//	this.vendorData.vendor = JSON.parse(JSON.stringify(data))
			this.toggleList.push({name:data.name})
			this.brandsList = [];
			this.vendorData.profile_brand_name = ""
			this.isLoading = false;
			if(data.id){
				this.getAllProfile(data.id)
			 }
			 else{
				 this.getAllProfile()
			 }
			},
			closeAddContactModal(data) {
				this.addedNewName = "";
				this.openAddNewContactModal = false;
				if (data.length) {
					switch (this.addedType) {
						case "client":
							this.vendorData.client_main_contact = data[0];
							break;
						case "market":
							this.vendorData.go_marketing = data[0];
							break;
						case "ops":
							this.vendorData.go_ops = data[0];
							break;
						case "retail":
							this.vendorData.go_retail = data[0];
							break;
					}
				}
			},
			customLabel(data) {
				if (!data.last_name) {
					return data.first_name;
				} else {
					return data.first_name + " " + data.last_name;
				}
			},
			updateName(query) {
				this.name = query;
			},
			addNew(val, type) {
				this.addedNewName = val;
				this.openAddNewContactModal = true;
				this.addedType = type;
			},
			// getGoCalls(payload) {
			// 	this.$store.dispatch("accounts/getGoCallList", payload);
			// },
			// searchClientFromDb(searchText) {
			// 	if (searchText != "") {
			// 		let payload = {
			// 			profile_id: this.$route.params.ProfileId,
			// 			q: searchText,
			// 			type: 'client_main_contact'
			// 		};
			// 		this.getGoCalls(payload)
			// 	}
			// },
			getContactsList() {
				let payload = { q: "" };
				let vm = this;
				this.$store
					.dispatch("accounts/getContactsList", payload)
					.then(res => {
						vm.contacts_list = res;
					});
			},
			navigateToListPage(data) {
				if (data == "cancel") {
					this.$store.state.calledFromCancel = true;
				}
				this.$router.push({ path: "/accounts" });
			},
			saveVendor() {
				this.submitted = true;
				if (this.validate()) {
					const vm = this;
					this.loader = true;
					this.vendorData.go_retail =
						(this.vendorData.go_retail || {}).id ||
						this.vendorData.go_retail;
					this.vendorData.go_ops =
						(this.vendorData.go_ops || {}).id || this.vendorData.go_ops;
					this.vendorData.go_marketing =
						(this.vendorData.go_marketing || {}).id ||
						this.vendorData.go_marketing;
					this.vendorData.client_main_contact =
						(this.vendorData.client_main_contact || {}).id ||
						this.vendorData.client_main_contact;
						this.vendorData.profile_brand_name = this.vendorData.profile_brand_name && this.vendorData.profile_brand_name.name ? this.vendorData.profile_brand_name.name : this.vendorData.profile_brand_name;


					this.vendorData.disable_date =  this.vendorData.disable_date
					this.vendorData.userName = JSON.parse(window.localStorage.session).name;
					this.$store
						.dispatch("accounts/addUpdateVendorData", this.vendorData)
						.then(res => {
							vm.loader = false;
							vm.navigateToListPage();
						});
					vm.submitted = false;
				} else {
				}
			},
			validate() {
				if (
					!this.vendorData.profile_brand_name ||
					this.vendorData.profile_brand_name == null ||
					this.vendorData.profile_brand_name == "null" ||
					!this.vendorData.vendor ||
					this.vendorData.vendor == null ||
					this.vendorData.vendor == "null" || !this.vendorData.country_code ||
					this.vendorData.country_code == null ||
					this.vendorData.country_code == "null"
				) {
					return false;
				} else {
					return true;
				}
			},
			checkIfAddOrEdit(id) {
				if (id) {
					this.isEditPage = true;
				} else {
					this.isEditPage = false;
					this.getAllVendor();
					//this.getAllProfile();
				}
			},
			getVendorDataById() {
				var pay = {
					profile_id: this.$route.params.ProfileId
				};
				this.loader = true;
				const vm = this;
				this.$store
					.dispatch("accounts/getVendorDataById", pay)
					.then(res => {

						vm.vendorData = res;
						vm.vendorData.profile_brand_name = res.profile_brand_name ? {name:res.profile_brand_name} : [];
						vm.vendorData.vendor = res.vendor_name ? {name:res.vendor_name, id:res.go_vendor_cd} : [];
						vm.getCogsList(res.go_vendor_cd)
						if(res.disable_date){
							vm.showDate = true;
							vm.disableDateCopy = res.disable_date;
							vm.vendorData.disable_date = moment(res.disable_date).utc().format("YYYY-MM-DD")
						}
						if (res.active) {
							vm.editable = false;
						}

						vm.isVendor = vm.vendorData.vendor && vm.vendorData.vendor.name ? true : false;
						vm.isCountryCode = res.country_code ? true : false;
						vm.isDataPull =( res && res.data_pull!=null && res.data_pull.toString()) ? true : false
						vm.isBaseApiUrl = res.base_api_url ? true : false
						vm.getAllVendor(res.vendor_name)

					//	vm.getAllProfile()

					});
			},
			getCogsList(data){

				let payload = {
					vendor_id :data
				}
				let vm = this;
				this.$store.dispatch("sales/getCogsList", payload).then((res) => {
					if(res){
						vm.cogs = res
					}
				})
			},
			getAllVendor(data){
				this.loader = true
				const vm = this;
				this.$store.dispatch("getAllVendor").then(res=>{
					vm.vendorList = res.filter(e=>e.name)
					vm.loader = false;
					if(vm.isEditPage){
						let selectedVendor = res.find(e=>e.name == data)
						if(selectedVendor.id){
							vm.getAllProfile(selectedVendor.id)
						}
					}
				})
			},
			getAllProfile(data){

				this.isLoadingBrand = true;
				let vm = this;
				let payload = {}
				if(data){
					payload = {
						vendorId:data
					}
					this.$store.dispatch("getAllBrandProfile", payload).then((res) => {
						vm.brandsList = res;
						vm.isLoadingBrand = false
					})
				}
				else{
					this.brandsList = [];
					this.isLoadingBrand = false
				}

			},
			getOtherBrandsList(){

				let payload = {
					id :this.$route.params.ProfileId
				}
				this.$store
					.dispatch("accounts/getOtherBrands", payload)
					.then(res => {
						this.otherBrands = res;
					});
			},
			changeprofile(profile, name){
				this.$router.push({
					path: "/addVendor" + "/" + profile
				});
				this.showDate = false;
				this.getVendorDataById()
				this.getData();
				document.querySelector('.tableauPlaceholder iframe').setAttribute('src', document.querySelector('.tableauPlaceholder iframe').getAttribute('src').replace(`&Profile Brand Name=${this.vendorData.profile_brand_name.name}`, `&Profile Brand Name=${name}`))
			//	document.getElementByClass('tableauViz').contentDocument.location.reload(true);
			}
		}
	};
</script>

<style lang="scss">
</style>
